import React, { useEffect, useState } from 'react';

import {
  MAX_MOBILE_WIDTH,
  OFFERS_SORTING_FIELD,
} from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/offersTableWrapper.constants';
import { OffersPageFilters } from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/offersTableWrapper.types';
import useMobileCheck from 'hooks/useMobileCheck';
import OffersTableMobile from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/OffersTableMobile/OffersTableMobile';
import OffersTable from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/OffersTable/OffersTable';
import { OffersTableColumnsTitle } from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/offersTableWrapper.enums';
import { OfferDto } from 'api/OffersApi';

export interface OffersTableWrapperProps {
  loanOffers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
}

const OffersTableWrapper = ({ loanOffers, onAcceptOffer, isDisabled }: OffersTableWrapperProps) => {
  const [sortedLoanOffers, setSortedLoanOffers] = useState<OfferDto[]>(loanOffers);
  const [filters, setFilters] = useState<OffersPageFilters>({
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.MonthlyPayments]!,
    isSortDesc: false,
  });
  const isMobile = useMobileCheck(MAX_MOBILE_WIDTH);

  useEffect(() => {
    const sortedOffers = [...loanOffers].sort((firstOffer, secondOffer) => {
      if (filters.isSortDesc) {
        return Number(secondOffer[filters.sortField]) - Number(firstOffer[filters.sortField]);
      }

      return Number(firstOffer[filters.sortField]) - Number(secondOffer[filters.sortField]);
    });

    setSortedLoanOffers(sortedOffers);
  }, [filters, loanOffers]);

  const updateTableSort = (sortField?: keyof OfferDto) => {
    if (!sortField) {
      return;
    }

    const isSortDesc = filters.sortField === sortField ? !filters.isSortDesc : true;

    setFilters({ sortField: sortField, isSortDesc: isSortDesc });
  };

  return isMobile ? (
    <OffersTableMobile
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  ) : (
    <OffersTable
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  );
};

export default OffersTableWrapper;
